import request from "root/js/request";

export const getSharesProductCategories = async ({
  shares_id,
  cabinet_id,
  product_id__in,
  subject_id__in,
  in_shares,
}) => {
  const response = await request({
    url: `/analytics/shares/${shares_id}/products_category/?cabinet_id=${cabinet_id}`,
    method: "get",
    params: {
      product_id__in,
      subject_id__in,
      in_shares,
    },
  });
  return response;
};
